import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const sleepAndRestFeatures: LandingPageFeature[] = [
  {
    id: 'sleep_score',
    description: 'sleep_and_rest_features_description_one',
    image: {
      format: 'png',
      localizedAlt: 'sleep_and_rest_features_one_img_alt',
      localizedSrc: 'sleep_and_rest_features_one_img',
    },
    title: 'sleep_and_rest_features_title_one',
  },
  {
    id: 'sleep_stages',
    description: 'sleep_and_rest_features_description_two',
    image: {
      format: 'png',
      localizedAlt: 'sleep_and_rest_features_two_img_alt',
      localizedSrc: 'sleep_and_rest_features_two_img',
    },
    title: 'sleep_and_rest_features_title_two',
  },
  {
    id: 'oxygen_saturation',
    description: 'sleep_and_rest_features_description_three',
    image: {
      format: 'png',
      localizedAlt: 'sleep_and_rest_features_three_img_alt',
      localizedSrc: 'sleep_and_rest_features_three_img',
    },
    title: 'sleep_and_rest_features_title_three',
  },
  {
    id: 'rest_mode',
    description: 'sleep_and_rest_features_description_four',
    image: {
      format: 'png',
      localizedAlt: 'sleep_and_rest_features_four_img_alt',
      localizedSrc: 'sleep_and_rest_features_four_img',
    },
    title: 'sleep_and_rest_features_title_four',
  },
];

export default sleepAndRestFeatures;
